// extracted by mini-css-extract-plugin
export default {"containerStyle":"GrowBusiness_containerStyle__FLO8i","content":"GrowBusiness_content__q+rHM"};